import { IconButton } from '@creditornot/cb-button';
import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import React from 'react';
import styled from 'styled-components';

import { WideAreaCheckbox } from 'common/components';
import { Typography as T } from 'common/typography';

import OfferTags from './OfferTags';
import { MENU_MOBILE_BREAKPOINT } from '../../constants';

export const Header = styled.div<{ hidden?: boolean; selected?: boolean; active?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 104px;
  background-color: ${({ active, selected }) => {
    if (active) {
      return colors.wolt8;
    }
    if (selected) {
      return colors.wolt4;
    }
    return cssThemedValue('surfaceMain');
  }};
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  transition: background-color 100ms;

  &:hover {
    background-color: ${({ selected }) =>
      selected ? colors.wolt8 : cssThemedValue({ light: colors.pepper8, dark: colors.salt4 })};
  }
`;

export const Left = styled.div<{ $hasAdditionalMargin?: boolean }>`
  display: flex;
  align-items: center;
  min-width: 0;
  margin-inline-start: ${({ $hasAdditionalMargin = false }) => ($hasAdditionalMargin ? '24px' : 0)};
`;

export const Right = React.memo(styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  padding: 24px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    padding: 16px;
  }
`);

export const NameAndDescription = styled.div<{ isHidden?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  padding: 16px 0;
  opacity: ${({ isHidden }) => (isHidden ? 0 : 1)};
  transition: opacity 200ms ease-in-out;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    padding: 8px 0;
  }
`;

export const ThumbnailContainer = styled.div`
  position: relative;
  margin-inline-end: 16px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-inline-end: 8px;
  }
  z-index: 1;

  &:hover + ${NameAndDescription} {
    opacity: 0;
  }
`;

export const NameAndTags = styled.div`
  display: flex;
  margin-block-end: 4px;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-block-end: 0;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const Name = styled(T.Body3).attrs({ fontWeight: 'bold' })`
  align-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${cssThemedValue('textPrimary')};
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    align-self: normal;
  }
`;

export const StyledTags = styled(OfferTags)`
  margin-inline-start: 12px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-inline-start: 0;
  }
`;

export const Description = styled(T.Body3)`
  color: ${cssThemedValue('textSecondary')};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledWideAreaCheckbox = styled(WideAreaCheckbox)`
  margin-inline-start: 8px;
  @media (max-width: ${MENU_MOBILE_BREAKPOINT}px) {
    margin-inline-start: 0;
  }
`;

export const StyledPopover = styled(Popover).attrs({
  placement: 'bottom-start',
  renderArrow: false,
})`
  display: flex;
  align-items: center;
`;

export const ToggleButton = styled(IconButton).attrs({ variant: 'blue', size: 'tiny' })``;

export const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 200px;
`;

export const Action = styled(MenuActionItem)`
  & + & {
    margin-block-start: 8px;
  }
`;
